import { authApiCall } from '../auth/saga';

export const getTaxRates = params => {
  return authApiCall({
    url: '/coupons/calculate-tax-rates/',
    method: 'get',
    params,
  });
};
